export default __webpack_public_path__ + "c8c55d8b1ea90038a248ca198b75cbf5.png";